import React, { useEffect, useState } from "react";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { onDownLoadPdfSAT } from "../Dashboard/DashboardFiscalMain";

export const AnticiposNoLigadosSection = ({ data }) => {
  const [anticipos, setAnticipos] = useState([]);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    setAnticipos(data);
  }, [data]);

  return (
    <div className="listado-fiscal-invoicemovimientos-container">
      <LoaderScreen loader={loader} />
      <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
        <table>
          <thead>
            <tr>
              {/* <th></th> */}
              <th>Sucursal</th>
              <th>
                <div>Departamento</div>
              </th>
              <th>
                <div>Cuenta</div>
              </th>
              <th>
                <div>Documento</div>
              </th>
              <th>
                <div>Fecha</div>
              </th>
              <th>
                <div>Importe</div>
              </th>
              <th>
                <div>Serie Fiscal</div>
              </th>
              <th>
                <div>Folio Fiscal</div>
              </th>
              <th>
                <div>Tipo de Comprobante</div>
              </th>
              <th>
                <div>Batch</div>
              </th>
              <th>
                <div>UUID</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {anticipos.map((ant, i) => (
              <tr key={i}>
                {/* <td className="ta-center">
                  <div className="options">
                    <div
                      className="boton-pdf"
                      onClick={() =>
                        onDownLoadPdfSAT(ant.documento, loader, setLoader)
                      }
                    >
                      <PictureAsPdfIcon />
                    </div>
                  </div>
                </td> */}
                <td className="ta-center">
                  {capitalizePalabras(ant.sucursal)}
                </td>
                <td className="ta-center">
                  {capitalizePalabras(ant.departamento)}
                </td>
                <td className="ta-center">{ant.cuenta}</td>
                <td className="ta-center">{ant.documento}</td>
                <td className="ta-center">
                  {new Date(ant.fecha).toLocaleDateString("es-MX", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </td>
                <td className="ta-right">{FormatMoney(ant.importe)}</td>
                <td className="ta-center">{ant.serie_fiscal}</td>
                <td className="ta-center">{ant.folio_fiscal}</td>
                <td className="ta-center">
                  {capitalizePalabras(ant.tipoComprobante)}
                </td>
                <td className="ta-center">{ant.batch}</td>
                <td className="ta-center">{ant.uuid}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
